(function () {
  function splitHeroTitle(root) {
    var title = root.querySelector('[data-rvrn-hero-title]');
    if (!title || title.dataset.rvrnReady === 'true') return;
    title.dataset.rvrnReady = 'true';

    var anim = root.getAttribute('data-rvrn-hero-anim') || 'letter-in';
    var showCursor = root.getAttribute('data-rvrn-hero-cursor') !== 'false';
    var accentWord = (title.getAttribute('data-rvrn-accent-word') || '').toUpperCase();
    var sourceLines = Array.prototype.slice.call(title.querySelectorAll('[data-rvrn-hero-line]'));
    if (!sourceLines.length) return;

    if (anim === 'none') return;

    var delay = 0;
    title.innerHTML = '';

    sourceLines.forEach(function (source, lineIndex) {
      var lineText = source.textContent || '';
      var line = document.createElement('span');
      line.className = 'rvrn-home-hero__title-line';
      if (source.getAttribute('data-rvrn-accent-line') === 'true') {
        line.className += ' rvrn-home-hero__title-line--accent';
      }

      lineText.split(/\s+/).filter(Boolean).forEach(function (word) {
        var wordEl = document.createElement('span');
        wordEl.className = 'rvrn-home-hero__title-word';
        if (accentWord && word.toUpperCase().replace(/[^\w]/g, '') === accentWord.replace(/[^\w]/g, '')) {
          wordEl.className += ' is-accent';
        }

        word.split('').forEach(function (char) {
          var letter = document.createElement('span');
          letter.className = 'rvrn-home-hero__letter';
          letter.textContent = char;
          if (anim === 'letter-in') {
            letter.style.animationDelay = delay + 'ms';
          }
          wordEl.appendChild(letter);
          delay += 55;
        });

        line.appendChild(wordEl);
        delay += 66;
      });

      title.appendChild(line);
      delay += lineIndex === sourceLines.length - 1 ? 0 : 120;
    });

    if (showCursor) {
      var cursor = document.createElement('span');
      cursor.className = 'rvrn-home-hero__cursor';
      var lastLine = title.querySelector('.rvrn-home-hero__title-line:last-child');
      if (lastLine) lastLine.appendChild(cursor);
    }
  }

  function playVideos(root) {
    var videos = root.querySelectorAll('video');
    videos.forEach(function (video) {
      if (video.dataset.rvrnHeroVideoReady === 'true') return;
      video.dataset.rvrnHeroVideoReady = 'true';
      video.addEventListener('loadedmetadata', function () {
        try {
          if (video.duration > 2) video.currentTime = 1.2;
        } catch (e) {}
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      }, { once: true });
    });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-rvrn-home-hero]').forEach(function (root) {
      splitHeroTitle(root);
      playVideos(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    if (window.RVRNReveal && window.RVRNReveal.init) {
      window.RVRNReveal.init(event.target);
    }
  });
})();
